export default [
    {
        path: '/ai-chat',
        name: 'AiChat',
        meta: { layout: 'default' },
        component: () => import('../AiChatComponent.vue')
    },
    {
        path: '/ai-chat/:chatId',
        name: 'AiChatConversation',
        meta: { layout: 'default' },
        component: () => import('../AiChatComponent.vue')
    }
]
